import { AuthSession, AuthUser, DevUser, LoginCredentials, LoginResponse } from '@/application/auth/authTypes';

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3010/api';

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  let response: Response;
  try {
    response = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: credentials.username.trim().toLowerCase(),
        password: credentials.password,
        twoFactorCode: credentials.twoFactorCode,
        twoFactorSecret: credentials.twoFactorSecret,
      }),
    });
  } catch {
    throw new Error('network_error');
  }

  if (response.status === 401) {
    throw new Error('invalid_credentials');
  }

  if (!response.ok) {
    throw new Error('login_failed');
  }

  return (await response.json()) as LoginResponse;
}

export async function getCurrentUser(token: string): Promise<AuthUser> {
  const response = await fetch(`${API_BASE}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error('unauthorized');
  }

  const data = (await response.json()) as { user: AuthUser };
  return data.user;
}

// ── Impersonación (solo dev; el endpoint no existe en producción) ──────────────

export async function listDevUsers(): Promise<DevUser[]> {
  const response = await fetch(`${API_BASE}/auth/dev/users`);
  if (!response.ok) {
    throw new Error('dev_users_unavailable');
  }
  const data = (await response.json()) as { users: DevUser[] };
  return data.users;
}

export async function impersonate(username: string): Promise<AuthSession> {
  const response = await fetch(`${API_BASE}/auth/dev/impersonate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username }),
  });

  if (!response.ok) {
    throw new Error('impersonate_failed');
  }

  return (await response.json()) as AuthSession;
}
